import { formatAppointmentDate, formatAppointmentTime, } from '@/helpers/dates';
const BRANCH_KEY = `BRANCH_KEY`;
const BRANCH_ADDRESS_KEY = `BRANCH_ADDRESS_KEY`;
const HUB_KEY = `HUB_KEY`;
const USER_LS_KEY = 'STORAGE_USER_DATA';
const ACCOUNT_LS_KEY = 'ACCOUNT_USER_DATA';
const USER_HEADERS_KEY = 'STORAGE_HEADERS_DATA';
const LOCALE_LS_KEY = 'LOCALE_KEY';
const SASS_FLOW_NAME = 'SASS_FLOW_NAME';
const APPOINTMENT_CALENDAR_PAGE_NAME = `AppointmentCalendarPage`;
const CONSULT_CALENDAR_PAGE_NAME = `ConsultCalendarPage`;
const MONTH_CALENDAR_PAGE_NAME = `MonthCalendarPage`;
const SHIFTS_CALENDAR_PARAM = 'shifts';
const ISO_MAPPING = [
    {
        iso: 'CHE',
        post_code_length: 4,
    },
    {
        iso: 'FRA',
        post_code_length: 5,
    },
];
const DEFAULT_POST_CODE_LENGTH = 5;
const VARIABLE_CATEGORIES = [
    'CLIENT',
    'APPOINTMENT',
    'ADVISOR',
    'ACCOUNT',
];
const CONDITIONAL_VARIABLE_NAMES = [
    'appointment_address',
    'appointment_address_details',
    'worker_phone',
    'appointment_video_conference_url',
];
const EMAIL_TEMPLATE_VARIABLES = [
    {
        name: 'client_first_name',
        category: 'CLIENT',
    },
    {
        name: 'client_last_name',
        category: 'CLIENT',
    },
    {
        name: 'account_name',
        category: 'ACCOUNT',
    },
    {
        name: 'appointment_date',
        category: 'APPOINTMENT',
    },
    {
        name: 'appointment_starting_time',
        category: 'APPOINTMENT',
    },
    {
        name: 'appointment_ending_time',
        category: 'APPOINTMENT',
    },
    {
        name: 'appointment_method_name',
        category: 'APPOINTMENT',
    },
    {
        name: 'appointment_address',
        category: 'APPOINTMENT',
        methods: [
            'location_category_on_site',
            'location_category_on_site_in_branch',
            'location_category_in_branch_public',
            'location_category_in_branch_private',
            'location_category_in_service_point',
        ],
    },
    {
        name: 'appointment_address_details',
        category: 'APPOINTMENT',
        methods: [
            'location_category_on_site',
            'location_category_on_site_in_branch',
            'location_category_in_branch_public',
            'location_category_in_branch_private',
            'location_category_in_service_point',
        ],
    },
    {
        name: 'appointment_video_conference_url',
        category: 'APPOINTMENT',
        methods: [
            'location_category_by_online_video',
            'location_category_in_branch_by_video_public',
            'location_category_in_branch_by_video_private',
            'location_category_in_branch_client_video_private',
        ],
    },
    {
        name: 'worker_name',
        category: 'ADVISOR',
    },
    {
        name: 'worker_phone',
        category: 'ADVISOR',
        methods: [
            'location_category_by_phone',
            'location_category_in_branch_by_phone_private',
            'location_category_in_branch_by_phone_public',
            'location_category_in_service_point_by_phone',
        ],
    },
];
const INSERT_VARIABLE_TARGETS = {
    header: {
        field: 'headerContent',
    },
    body: {
        field: 'bodyContent',
    },
    additionalText: {
        field: 'additionalText',
    },
    footer: {
        field: 'footerContent',
    },
};
const getPreviewVariables = (locale) => ({
    client_first_name: 'Marie',
    client_last_name: 'Dominique',
    client_email: 'marie.dominique@example.com',
    account_name: 'ADIL 76',
    appointment_date: formatAppointmentDate(new Date(2026, 3, 28), locale),
    appointment_starting_time: formatAppointmentTime('2:00 PM', locale),
    appointment_ending_time: formatAppointmentTime('2:30 PM', locale),
    appointment_method_name: 'In branch',
    appointment_address: '5 rue Louis Blanc, 76000 Rouen',
    appointment_address_details: 'Bâtiment A, 2e étage',
    appointment_video_conference_url: 'https://meet.calizy.com/demo',
    worker_name: 'Sophie Martin',
    worker_phone: '06 12 34 56 78',
});
export { BRANCH_ADDRESS_KEY, BRANCH_KEY, HUB_KEY, USER_LS_KEY, ACCOUNT_LS_KEY, USER_HEADERS_KEY, LOCALE_LS_KEY, SASS_FLOW_NAME, APPOINTMENT_CALENDAR_PAGE_NAME, CONSULT_CALENDAR_PAGE_NAME, MONTH_CALENDAR_PAGE_NAME, SHIFTS_CALENDAR_PARAM, ISO_MAPPING, DEFAULT_POST_CODE_LENGTH, VARIABLE_CATEGORIES, CONDITIONAL_VARIABLE_NAMES, EMAIL_TEMPLATE_VARIABLES, INSERT_VARIABLE_TARGETS, getPreviewVariables, };
